import React, { useState } from 'react';
import pearClient from 'api/pearClient';
import { HyliaApiClientInstance } from 'api/hyliaApiClientInstance';
import Tooltip from 'components/common/Tooltip';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import CircularLoader from 'components/common/CircularLoader';
import downloadFile from 'utils/downloadFile';
import getFileNameFromContentDisposition from 'utils/getFileNameFromContentDisposition';
import { IDownloadSnapshotButtonProps } from './types';
import './styles.scss';

/**
 * A button that downloads a patient snapshot pdf.
 * @param props The props
 * @return A JSX Element
 */
function DownloadSnapshotButton(
  props: IDownloadSnapshotButtonProps,
): JSX.Element {
  const { patientId, rxId } = props;
  const [loading, setLoading] = useState(false);

  async function onClick(
    event: React.MouseEvent<HTMLDivElement>,
  ): Promise<void> {
    event.stopPropagation();
    setLoading(true);
    try {
      const { data, headers } =
        await HyliaApiClientInstance.getPatientSnapshotPdf(patientId, rxId);
      const filename = getFileNameFromContentDisposition(
        headers['content-disposition'],
        'snapshot.pdf',
      );
      downloadFile(data, filename);
      pearClient.v2.tracking.trackDownloadPatientSnapshot(patientId);
    } catch (e) {
      ErrorInterceptor.error(e);
    }
    setLoading(false);
  }

  return loading ? (
    <CircularLoader
      wrapperWidth={18}
      wrapperHeight={18}
      width={18}
      height={18}
      top="0"
      left="0"
    />
  ) : (
    <Tooltip
      title={
        <>
          Download Patient Snapshot
          <br />
          (Contains PHI)
        </>
      }
      placement="top"
    >
      <div
        styleName="download-snapshot-button"
        data-testid="download-snapshot-button"
        onClick={onClick}
      />
    </Tooltip>
  );
}

export default DownloadSnapshotButton;
